import { FC } from 'react'
import { AppHead } from 'client/components/ProfileLayout/components/AppHead/AppHead'
import { ProfileLayout } from 'client/components/ProfileLayout/ProfileLayout'
import { ProfileOrderPageContent } from 'client/contents/ProfileOrderContent/ProfileOrderContent'

type TProps = {}

const ProfileOrderPage: FC<TProps> = () => {
  return (
    <article className="bg-surface-white flex h-full w-full flex-col">
      <AppHead />
      <ProfileOrderPageContent />
    </article>
  )
}

// @ts-ignore
ProfileOrderPage.layout = (page) => <ProfileLayout children={page}></ProfileLayout>

export default ProfileOrderPage
